var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAccessRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 18.8H14.25V21.8H17.25V18.8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 18.8H19.5V21.8H22.5V18.8Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 13.55H14.25V16.55H17.25V13.55Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 13.55H19.5V16.55H22.5V13.55Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 18.8H3V8.30005H21V12.05H22.5V8.30005C22.4995 7.90236 22.3414 7.5211 22.0602 7.23989C21.7789 6.95869 21.3977 6.80051 21 6.80005H16.5V3.80005C16.4995 3.40236 16.3414 3.0211 16.0602 2.73989C15.7789 2.45869 15.3977 2.30051 15 2.30005H9C8.6023 2.30045 8.221 2.45861 7.93978 2.73983C7.65856 3.02105 7.5004 3.40235 7.5 3.80005V6.80005H3C2.6023 6.80045 2.221 6.95861 1.93978 7.23983C1.65856 7.52105 1.5004 7.90235 1.5 8.30005V18.8C1.50046 19.1977 1.65864 19.579 1.93984 19.8602C2.22105 20.1414 2.60232 20.2996 3 20.3H12.75V18.8ZM9 3.80005H15V6.80005H9V3.80005Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAccessRight);
export default __webpack_public_path__ + "static/media/ic-access-right.1e6ed826c11e33f881e68f9166f1c33f.svg";
export { ForwardRef as ReactComponent };